import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';

import type { IWbuMultilineTextInputProps } from '../WbuMultilineTextInput.props';

export const props = withCompInfo<IWbuMultilineTextInputProps, any>()(
  ['compData'],
  ({ compData }) => ({
    ...compData,
  }),
);

export default createComponentMapperModel({
  props,
});
